export default "__VITE_ASSET__39eb6bcd__"